import { EducationProgram } from "../models/EducationPrograms";
import http from "./httpRequest";



class EducationProgramsService {
    // Crud operations for education programs
    async getEducationPrograms() {
        let response = await http.get<EducationProgram[]>('/education-programs');
        return response.data;
    }

    async getEducationProgram(id: number) {
        let response = await http.get(`/education-programs/${id}`);
        return response;
    }

    async createEducationProgram(data: EducationProgram) {
        let response = await http.post('/education-programs', data);
        return response;
    }

    async updateEducationProgram(id: number, data: EducationProgram) {
        let response = await http.put(`/education-programs/${id}`, data);
        return response;
    }

    async deleteEducationProgram(id: number) {
        let response = await http.delete(`/education-programs/${id}`);
        return response;
    }
}

export default new EducationProgramsService();